<template>
  <div>
    <a-row class="content-fix org">
      <a-row class="content-title" type="flex">
        <a-button
          type="primary"
          class="back-btn"
          @click="$router.push({ name: 'statistics' })"
        >
          <i class="t-transition icons icon-chevron-left" />
          Назад
        </a-button>
      </a-row>

      <a-table :columns="columns" :data-source="years.data" row-key="id">
        <!-- year column -->
        <div
          slot="name"
          slot-scope="item"
          style="cursor: pointer"
          @click="openYear(item.year)"
        >
          {{ item.year }}
        </div>

        <!-- action column -->
        <!-- <span slot="action" slot-scope="item">
          <a-button type="link" @click="openYear(item)">
            Открыть
          </a-button>
        </span> -->
      </a-table>
    </a-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"

export default {
  data() {
    return {
      columns: [
        {
          title: "Годы",
          key: "years",
          scopedSlots: { customRender: "name" }
        }
        // {
        //   title: "Действия",
        //   key: "action",
        //   scopedSlots: { customRender: "action" }
        // }
      ]
    }
  },

  computed: {
    ...mapGetters({
      years: "mtms/getYears"
    })
  },

  mounted() {
    this.fetchYears()
  },

  methods: {
    ...mapActions({
      fetchYears: "mtms/fetchYears"
    }),

    openYear(year) {
      this.$router.push({
        name: "mtms-year",
        params: { year }
      })
    }
  }
}
</script>

<style>
.wanted-search-input-wrapper {
  flex: 0 0 430px;
  justify-content: space-around;
}
</style>
